import React from 'react';
import cx from 'classnames';
import delIconCavity from './images/close-mini.svg';
import Icon from '../Icon';

export default function ValueItem({
  value = {},
  valueColor,
  onRemove,
  disabled
}) {
  const classes = cx('multi-select-value', {
    disabled: disabled || value.disabled
  });

  const color = disabled || value.disabled ? '#444' : valueColor;
  return (
    <div className={classes} style={{ background: color, borderColor: color }}>
      <span>{value.label || value.value}</span>
      <span
        onClick={e => {
          e.stopPropagation();
          onRemove(value);
        }}
        style={{ cursor: 'pointer' }}
      >
        <Icon className="multi-item-del-icon" link={delIconCavity} />
      </span>
    </div>
  );
}
